import React from "react";
import "./styles.css";

const Header = () => {
  return (
    <header>
      <h1>FAQ Page</h1>
    </header>
  );
};

export default Header;
